import React from "react"
import {Row} from "react-bootstrap"

import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import {H4, Body} from "@irati/ui/src/Typography"

import {StyledCol, StyledImage, LoginCard, HelpCard} from "./styled"

interface Props {
  id?: string,
  image?: string,
  alignTop?: boolean,
  helpLinks?: JSX.Element[]
}

const LoginBlock: React.FC<Props> = (props) => {
  const {children, image, helpLinks, alignTop} = props
  const idNamespace = id("login-block", props)

  return (
    <Row id={idNamespace}>
      <StyledCol id={id("col", idNamespace)} xs={12} withImage={!!image} alignTop={alignTop}>
        {image && <StyledImage src={image} alt="" />}
        <LoginCard withBottomPanel={!!helpLinks} withImage={!!image}>
          {children}
        </LoginCard>
        {helpLinks && (
          <HelpCard>
            <H4 marginBottom={1}>
              <FormattedMessage id="platform.login.header.needHelp" />
            </H4>
            {helpLinks.map((helpLink, index) => (
              <Body small marginTop={1} key={index}>
                {helpLink}
              </Body>
            ))}
          </HelpCard>
        )}
      </StyledCol>
    </Row>
  )
}

LoginBlock.defaultProps = {
  size: "small"
}

export default LoginBlock
